import { useEffect, useRef } from "react";

// Nothing on the page holds focus: it went with the removed card, or it is
// still in the closing confirmation dialog, which would hand it back to a
// control that no longer exists.
const focusLost = () => {
  const active = document.activeElement;
  return !active || active === document.body || !active.isConnected || Boolean(active.closest('[role="dialog"]'));
};

const neighbourOf = (previous, current, removed) => {
  const index = previous.indexOf(removed);
  const remaining = (keys) => keys.find((key) => current.includes(key));
  return remaining(previous.slice(index + 1)) || remaining(previous.slice(0, index).reverse()) || null;
};

// When one card leaves the shown list and takes the focus with it (an archive),
// focus moves to the next card's primary control, else the previous card's,
// else `onNoneLeft` decides (Create Groups, or the empty state's title).
export const useFocusAfterRemoval = (shownKeys, focusControlOf, onNoneLeft) => {
  const previousRef = useRef(shownKeys);
  const signature = shownKeys.join("|");

  useEffect(() => {
    const previous = previousRef.current;
    previousRef.current = shownKeys;
    const removed = previous.filter((key) => !shownKeys.includes(key));
    if (removed.length !== 1 || !focusLost()) return;
    const neighbour = neighbourOf(previous, shownKeys, removed[0]);
    if (neighbour) focusControlOf(neighbour)?.focus();
    else onNoneLeft?.();
    // Runs when the set of shown cards changes, not on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature]);
};
